// extracted by mini-css-extract-plugin
export default {"tech-containerLight":"TechCard_tech-containerLight__CysjO","tech-containerDark":"TechCard_tech-containerDark__8eyuX","main":"TechCard_main__DFAxF"};